import { GetDisplayableFeedbackQuestionnaireRequest } from '@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1';
import pickBy from 'lodash/pickBy';
import { UPDATE_QUESTIONNAIRE } from './type';
import { getTransCustomerFeedbackAggreatorServiceClient } from '../../clients/TransCustomerFeedbackAggreatorServiceClient';
import {
  IS_GET_QUESTIONS_INPROGRESS,
  IS_SURVEY_ENABLED,
  SHOW_FAILURE_NOTIFICATION,
} from '../ui/type';
import { CSAT_SURVEY_FEEDBACKINTENT } from '../../constants/FeedbackConstants';

/** @typedef {{type: string, payload: any}} Action */

/**
 * Get questionnaire request action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @returns {(dispatch: Function) => Promise<Action>}
 */
export const getQuestions =
  (applicationId, feedbackIntent) => (dispatch, uiDispatch) => {
    const getFeedbackQuestionnaireRequest =
      GetDisplayableFeedbackQuestionnaireRequest?.clone({
        applicationId,
        feedbackIntent,
      });
    const client = getTransCustomerFeedbackAggreatorServiceClient();
    uiDispatch({ type: IS_GET_QUESTIONS_INPROGRESS, payload: true });
    return client
      .getDisplayableFeedbackQuestionnaire(getFeedbackQuestionnaireRequest)
      .toPromise()
      .then(({ questionnaire, display }) => {
        if (feedbackIntent.includes(CSAT_SURVEY_FEEDBACKINTENT) && !display) {
          uiDispatch({ type: IS_SURVEY_ENABLED, payload: false });
        }
        dispatch({
          type: UPDATE_QUESTIONNAIRE,
          payload: questionnaire.map((question) => {
            return {
              ...question,
              questionType: pickBy(question.questionType, (value) => value),
            };
          }),
        });
        uiDispatch({ type: IS_GET_QUESTIONS_INPROGRESS, payload: false });
      })
      .catch(() => {
        uiDispatch({ type: SHOW_FAILURE_NOTIFICATION });
        uiDispatch({ type: IS_GET_QUESTIONS_INPROGRESS, payload: false });
      });
  };

export default {
  getQuestions,
};
